/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Prompt1/view.blocks to change it.
import * as fromData from 'Simple/Data'
import * as fromDesignTokens from 'Simple/DesignTokens'
import * as fromFlow from 'Simple/Flow'
import * as fromHelpers from './helpers.js'
import Prompt from 'DesignSystem/Questions/Prompt/index'
import React from 'react'
import TysiaText from 'DesignSystem/TysiaText/index'
import styles from './view.module.css'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function Prompt1({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Prompt"
  
}) {
let dtSpaceXxs = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'space.xxs'
        })
let widgetQuestionsValueData = fromData.useDataValue({ viewPath,
context: 'widget',
path: 'questions',
})
let questionPromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'prompt',
})
let selectedAnswersValueData = fromData.useDataValue({ viewPath,
context: 'selected',
path: 'answers',
})
let questionTypeValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'type',
})
let aggregateData = fromHelpers.populateTemplate(widgetQuestionsValueData, questionPromptValueData, selectedAnswersValueData, questionTypeValueData)
let questionSubpromptValueData = fromData.useDataValue({ viewPath,
context: 'question',
path: 'subprompt',
})
let questionSubpromptValueData1 = fromData.useDataValue({ viewPath,
context: 'question',
path: 'subprompt',
})
let dtTypographyMm = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.mm'
        })
let dtTypographyM = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'typography.m'
        })
let dtColorsNeutral500 = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.neutral.500'
        })
  return (<React.Fragment
>
<div
  data-testid="Prompt.Vertical"
  data-view-path={viewPath}
 style={{'--g-1-Z2eUPX2': typeof dtSpaceXxs === 'number' ? `${dtSpaceXxs}px` : dtSpaceXxs}}
 className={`views-block ${styles.Vertical}`}
>
<Prompt
  viewPath={`${viewPath}/Prompt`}
 marginTop={0}
 marginBottom={0}
 data="widget.questions"
 data="question.prompt"
 data="selected.answers"
 data="question.type"
 aggregate="helpers.js populateTemplate"
 text={aggregateData}
/>
<fromFlow.When is={questionSubpromptValueData}>
<TysiaText
  viewPath={`${viewPath}/TysiaText`}
 data="question.subprompt"
 fontSize={dtTypographyMm}
 lineHeight={dtTypographyM}
 color={dtColorsNeutral500}
 data="question.subprompt"
 text={questionSubpromptValueData1}
/>
</fromFlow.When>
</div>
{children}
</React.Fragment>)
}